import { render } from "./FeedIsLoading.vue?vue&type=template&id=9c2f5d6e&scoped=true"
import script from "./FeedIsLoading.vue?vue&type=script&lang=js"
export * from "./FeedIsLoading.vue?vue&type=script&lang=js"

import "./FeedIsLoading.vue?vue&type=style&index=0&id=9c2f5d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c2f5d6e"]])

export default __exports__